/** Reference RightSideBar rules (casino/rules API) per poker-cluster game — our backend has no rules API. */
export const PAIR_PLUS_RULES = [
  {
    hed: "Pair Plus",
    rows: [
      ["Pair", "1 TO 1"],
      ["Flush", "1 TO 4"],
      ["Straight", "1 TO 6"],
      ["Trio", "1 TO 30"],
      ["Straight Flush", "1 TO 40"],
    ],
  },
];

export const POKER_BONUS_RULES = [
  {
    hed: "Bonus 1 (2 Cards Bonus)",
    rows: [
      ["Pair (2-10)", "1 TO 3"],
      ["A/Q or A/J Off Suited", "1 TO 5"],
      ["Pair (JQK)", "1 TO 10"],
      ["A/K Off Suited", "1 TO 15"],
      ["A/Q or A/J Suited", "1 TO 20"],
      ["A/K Suited", "1 TO 25"],
      ["A/A", "1 TO 30"],
    ],
  },
  {
    hed: "Bonus 2 (7 Cards Bonus)",
    rows: [
      ["Three of a Kind", "1 TO 3"],
      ["Straight", "1 TO 4"],
      ["Flush", "1 TO 6"],
      ["Full House", "1 TO 8"],
      ["Four of a Kind", "1 TO 30"],
      ["Straight Flush", "1 TO 50"],
      ["Royal Flush", "1 TO 100"],
    ],
  },
];
